import React, { useContext, useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";
import configContext from "../../../context/configContext/configContext";
import { useFormik } from "formik";
import * as Yup from "yup";

const initialValues = {
  email: "",
  statement: "",
  themes: "",
  category: "",
};

const StudentShareIdea = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string().min(2, "Enter a Advertisement Title"),
      statement: Yup.string()
        .min(2, "Enter Advertisement Description")
        .required("Please Enter Your Advertisement Description"),
      themes: Yup.string().min(2, "Select Date").required("Please Select date"),
      category: Yup.string()
        .min(2, "Enter Location")
        .required("Please Enter Location"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post("/ideas/addinnovative_ideas", values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Idea Sent successfully");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  return (
    <>
      <section className="">
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-8">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className=" ">
                    <div className="card-body p-4 text-black">
                      <form onSubmit={handleSubmit}>
                        <h5
                          className="fw-normal mb-3 pb-3"
                          style={{ letterSpacing: 1 }}
                        >
                          Share Idea
                        </h5>
                        <div className="form-outline mb-2">
                          <TextField
                            name="email"
                            margin="dense"
                            type="text"
                            placeholder="Email"
                            variant="outlined"
                            label=" Email"
                            value={values.email}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.email ? (
                            <p className="text-danger">{errors.email}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="statement"
                            margin="dense"
                            type="text"
                            placeholder="Statement"
                            variant="outlined"
                            label="Statement"
                            value={values.statement}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.statement ? (
                            <p className="text-danger">{errors.statement}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="themes"
                            margin="dense"
                            type="text"
                            placeholder="themes"
                            variant="outlined"
                            label="themes"
                            value={values.themes}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.themes ? (
                            <p className="text-danger">{errors.themes}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="category"
                            margin="dense"
                            type="text"
                            placeholder="Category"
                            variant="outlined"
                            label="Category"
                            value={values.category}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.category ? (
                            <p className="text-danger">{errors.category}</p>
                          ) : null}
                        </div>

                        <div className="pt-1 mb-2">
                          <Button variant="contained">Submit</Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StudentShareIdea;
